import { dateOf } from "@repo/helpers";
import { Col, Row } from "@repo/ui";
import { FC, ReactNode } from "react";

import { RepStatusEnum } from "../../models/rep";
import style from "./style.module.scss";

interface DeactivationDetailsProps {
	active: boolean;
	statusEnum: RepStatusEnum;
	deactivationDate: Date;
	deactivationReason: string;
}

export const DeactivationDetails: FC<DeactivationDetailsProps> = (props) => {
	const { statusEnum, deactivationDate, deactivationReason } = props;

	const deactivatedStatuses = [RepStatusEnum.Suspended, RepStatusEnum.Deactivated, RepStatusEnum.Terminated];
	if (!deactivatedStatuses.includes(statusEnum)) return null;

	return (
		<Row tag="section">
			<Col md="12">
				<table className={style.table}>
					<tbody>
						<TableItem value={dateOf(deactivationDate)} label="Deactivation Date" />
						<TableItem value={deactivationReason || "None"} label="Deactivation Reason" />
					</tbody>
				</table>
				<hr className={style.horizontalDivider} />
			</Col>
		</Row>
	);
};

interface TableItemProps {
	nullIfEmpty?: boolean;
	value: string | ReactNode;
	label: string;
}

const TableItem: FC<TableItemProps> = (props) => {
	if (props.nullIfEmpty && !props.value) return null;

	return (
		<tr key={props.label}>
			<Col tag="td" md="5">
				<label>{props.label}</label>
			</Col>
			<Col tag="td" md="7">
				{props.value}
			</Col>
		</tr>
	);
};
